module.exports = __webpack_public_path__ + "static/img/kescilab-color.7e8c25f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kescilab-color.png
// module id = i6/M
// module chunks = 0